import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

// 201607080003  中国循环杂志
// 201607080003  中医药杂志
//项目皮肤主题色
import './assets/css/skin.css'
//配置杂志ID
Vue.prototype.$_JournalId = 201607080003;
import router from './router/router.js'
//兼容ie9
import 'babel-polyfill'
//封装的加载loading
import loading from './utils/loading.js'
Vue.use(loading)
//所有接口
import Httphelper from './utils/api.js'
Vue.prototype.$httphelper = Httphelper;
//MD5加密
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
//阿里图标
import './assets/css/iconfont.css'
//无缝滚动轮播
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js